import { motion } from "framer-motion";
import { ArrowRight, Mail } from "lucide-react";

const BG = "/blue-waves.png";
const EMAIL = "inquiries@cameronbergsma.com";

export default function CTA() {
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.05 },
    },
  };
  const item = {
    hidden: { y: 18, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 110, damping: 14 },
    },
  };

  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-20 md:py-32 border-t border-white/10 bg-black"
    >
      <div className="mx-auto max-w-[1760px] px-4 md:px-8 lg:px-10">
        <div
          data-testid="cta-card"
          className="relative w-full overflow-hidden rounded-2xl md:rounded-3xl border border-white/10 bg-black text-white shadow-2xl"
        >
          <img
            src={BG}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover"
            style={{ filter: "hue-rotate(150deg) saturate(1.15)" }}
          />
          <div
            aria-hidden
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(110deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.75) 38%, rgba(0,0,0,0.45) 65%, rgba(0,0,0,0.2) 100%)",
            }}
          />

          <motion.div
            className="relative z-10 grid h-full grid-cols-1 items-center gap-10 p-8 md:grid-cols-2 md:gap-12 md:p-12 lg:p-16"
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            {/* Left: headline */}
            <div className="flex flex-col items-start text-left">
              <motion.div
                className="flex items-center gap-3 mb-5 md:mb-6"
                variants={item}
              >
                <span className="h-px w-10 bg-white/30" />
                <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-white/65">
                  Closing Note · 02 / 02
                </span>
              </motion.div>

              <motion.h2
                className="font-display font-black tracking-tighter leading-[0.92] text-3xl md:text-4xl lg:text-5xl"
                variants={item}
                data-testid="cta-card-title"
              >
                <span className="text-white">Have an </span>
                <span
                  className="font-script italic font-normal block leading-[1] whitespace-nowrap text-4xl md:text-5xl lg:text-6xl mt-1 md:mt-2 pr-2 pb-2"
                  style={{
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #FCA5A5 25%, #DC2626 55%, #7F1D1D 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    paddingBottom: "0.3em",
                  }}
                >
                  impossible idea?
                </span>
              </motion.h2>

              <motion.p
                className="mt-5 md:mt-6 max-w-md text-sm md:text-base text-white/70 leading-relaxed"
                variants={item}
              >
                He doesn't take every meeting — but he reads every message.
                Drop him a line.
              </motion.p>
            </div>

            {/* Right: email CTA */}
            <motion.div
              variants={item}
              data-testid="cta-email-block"
              className="w-full md:max-w-[480px] md:ml-auto rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-md p-6 md:p-7 flex flex-col gap-5"
            >
              <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-white/55">
                Direct line
              </span>
              <a
                href={`mailto:${EMAIL}?subject=Impossible%20idea`}
                data-testid="cta-email-link"
                className="group inline-flex items-center gap-3 text-white hover:text-white"
              >
                <Mail className="h-4 w-4 text-[#FCA5A5] shrink-0" />
                <span className="font-display font-black tracking-tight text-lg md:text-xl leading-tight break-all">
                  {EMAIL}
                </span>
              </a>
              <a
                href={`mailto:${EMAIL}?subject=Impossible%20idea`}
                data-testid="cta-email-button"
                className="cta-clay-blue group inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full text-xs md:text-sm font-mono font-semibold uppercase tracking-[0.2em] text-white"
              >
                <span className="relative z-10">Email Cameron</span>
                <ArrowRight className="relative z-10 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </a>
              <p className="text-[11px] text-white/45 leading-relaxed">
                He reads every message — replies to the brave ones.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
